var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSortGenreActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 7.5C50 3.375 46.625 0 42.5 0H7.5C3.375 0 0 3.375 0 7.5V42.5C0 46.625 3.375 50 7.5 50H42.5C46.625 50 50 46.625 50 42.5V7.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8864 30.9933C41.5605 31.4748 41.7166 32.4116 41.2351 33.0857L38.7351 36.5857C38.2536 37.2599 37.3168 37.416 36.6427 36.9345C35.9686 36.453 35.8124 35.5161 36.2939 34.842L38.7939 31.342C39.2754 30.6679 40.2123 30.5118 40.8864 30.9933ZM35.5145 40.2139C35.5145 40.8595 35.1014 41.4327 34.4889 41.6369C33.8764 41.8411 33.2019 41.6304 32.8145 41.1139L26.8145 33.1139C26.3175 32.4511 26.4518 31.5109 27.1145 31.0139C27.7773 30.5168 28.7175 30.6511 29.2145 31.3139L32.5145 35.7139L32.5145 9.71387C32.5145 8.88544 33.1861 8.21387 34.0145 8.21387C34.843 8.21387 35.5145 8.88544 35.5145 9.71387L35.5145 40.2139Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01465 14.4639C9.01465 13.4974 9.79815 12.7139 10.7646 12.7139H25.2646C26.2311 12.7139 27.0146 13.4974 27.0146 14.4639V14.4639C27.0146 15.4304 26.2311 16.2139 25.2646 16.2139H10.7646C9.79815 16.2139 9.01465 15.4304 9.01465 14.4639V14.4639Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01465 21.4639C9.01465 20.4974 9.79815 19.7139 10.7646 19.7139H19.2646C20.2311 19.7139 21.0146 20.4974 21.0146 21.4639V21.4639C21.0146 22.4304 20.2311 23.2139 19.2646 23.2139H10.7646C9.79815 23.2139 9.01465 22.4304 9.01465 21.4639V21.4639Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01465 28.4639C9.01465 27.4974 9.79815 26.7139 10.7646 26.7139H16.2646C17.2311 26.7139 18.0146 27.4974 18.0146 28.4639V28.4639C18.0146 29.4304 17.2311 30.2139 16.2646 30.2139H10.7646C9.79815 30.2139 9.01465 29.4304 9.01465 28.4639V28.4639Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSortGenreActive);
export default __webpack_public_path__ + "static/media/ic_sort_genre_active.82ce13ed198a95c618c8c7404286d004.svg";
export { ForwardRef as ReactComponent };